import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { ProductService } from '../service/product-service';
import { ProductWithStruct, UserProductData } from '../utils/commonTypes';
import { Product } from '../amplify/data-resource';
import { StoreService } from '../service/store-service';
import { withStorageSync } from '@angular-architects/ngrx-toolkit';
import { UserStore } from './user.store';
import { ProgressStore } from './progress.store';

type ProductState = {
  userProducts: UserProductData[],

  selectedProductId: string | null
  selectedProduct: ProductWithStruct
  isLoading: boolean;
  isLoadingUserProducts: boolean;

  allProducts: Product[],
  isLoadingAllProducts:boolean,
};

const initialState: ProductState = {
  userProducts: [],

  selectedProductId: null,
  selectedProduct: <ProductWithStruct>{},
  isLoading: false,
  isLoadingUserProducts:false,


  allProducts:[],
  isLoadingAllProducts:false,
};

export const ProductStore = signalStore(
  { providedIn: 'root' },
  // withStorageSync({
  //   key: 'product-store-synced',
  //   autoSync: true,
  //   select: ((state: ProductState) => ({
  //     // userProducts: state.userProducts,
  //     selectedProduct: state.selectedProduct,
  //     selectedProductId: state.selectedProductId,
  //   })) as (state: any) => Partial<any>,
  // }),

  withState(initialState),
  withMethods((store, 
    service = inject(ProductService), 
    storeService = inject(StoreService), 
    userStore = inject(UserStore), 
    progressStore = inject(ProgressStore)
  ) => ({
    
    reset(){
      patchState(store, {
        userProducts: [],
        selectedProductId: null,
        selectedProduct: <ProductWithStruct>{},
        isLoading: false,
        isLoadingUserProducts:false,
        allProducts:[],
        isLoadingAllProducts:false,
        // progressCache: [],
        // isLoadingProgress:false,
      });
    },

    async loadUserProducts(): Promise<boolean> {
      const user = userStore.profile();
      if(!user || store.isLoadingUserProducts()) {
        return false;
      }

      patchState(store, { isLoadingUserProducts: true });
      const products = await service.loadUserProducts(user.id);
      patchState(store, { isLoadingUserProducts: false, userProducts: products });
      return true;
    },

    async loadAllProducts(): Promise<boolean> {
      //Tries to load the product
      if (!store.isLoadingAllProducts()) {
        patchState(store, { isLoadingAllProducts: true });
        const products = await storeService.loadAllProducts();
        patchState(store, { isLoadingAllProducts: false, allProducts: products });
      }
      return true;
    },

    async loadProduct(productId: string): Promise<boolean> {
      if (!store.isLoading()) {
        patchState(store, { isLoading: true });
        const product = await service.findProductById(productId);
        console.log('Product retrieved',product);

        if (product) {
          //Triggers an async attempt to load the product's progress
          progressStore.loadProgress(productId);
          patchState(store, { isLoading: false, selectedProductId: productId, selectedProduct: product });
          return true;
        } else {
          patchState(store, { isLoading: false, selectedProductId: null });
          return false;
        }
      } else {
        return false; //ongoing load product or product already loaded
      }
    },
  }))
);

